import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import './alert-dialog.css'
import CustomButtonComponent from '../buttons/customButtonComponent/CustomButtonComponent'
import { EVENT_BACKDROP_CLICK, EVENT_ESCAPE_KEY_DOWN } from '../../utils/constants'

const isStringOrStringObject = (value) => typeof value === 'string' || value instanceof String

const useStyles = makeStyles(() => ({
  content: {
    padding: '3rem',
    paddingBottom: '4.5rem',
  },
  dialogTitle: {
    '& h2': {
      position: 'relative',
      top: '1rem',
      fontSize: '1.5rem',
      left: '10px',
    },
  },
}))

const CustomDialogContent = ({ dialogContent }) => {
  const classes = useStyles()
  if (isStringOrStringObject(dialogContent)) {
    return (
      <DialogContentText className={classes.content} id='alert-dialog-description'>
        {dialogContent}
      </DialogContentText>
    )
  }
  return (
    <DialogContent className={classes.content} id='alert-dialog-description'>
      {dialogContent}
    </DialogContent>
  )
}

CustomDialogContent.propTypes = {
  dialogContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

CustomDialogContent.defaultProps = {
  dialogContent: '',
}

const AlertDialog = ({
  openAlert,
  title,
  translatedTitle,
  dialog,
  acceptButtonText,
  acceptButtonAction,
  acceptButtonType,
  cancelButtonText,
  disable,
  handleClose,
  fullWidth,
  maxWidth,
}) => {
  const intl = useIntl()
  const classes = useStyles()

  const onClose = (event, reason) => {
    if (reason !== EVENT_BACKDROP_CLICK && reason !== EVENT_ESCAPE_KEY_DOWN && typeof handleClose === 'function') {
      handleClose()
    }
    return false
  }

  return (
    <div>
      <Dialog
        open={openAlert}
        onClose={onClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
        {title && (
          <DialogTitle id='alert-dialog-title' classes={{ root: classes.dialogTitle }}>
            {translatedTitle ? title : intl.formatMessage({ id: title })}
          </DialogTitle>
        )}
        <CustomDialogContent dialogContent={dialog} />
        <DialogActions>
          <div className='buttonsFlex'>
            {acceptButtonText && acceptButtonAction && (
              <CustomButtonComponent
                label={acceptButtonText}
                onClick={acceptButtonAction}
                type={acceptButtonType}
                disabled={disable}
              />
            )}
            {cancelButtonText && handleClose && (
              <CustomButtonComponent label={cancelButtonText} primary={false} onClick={handleClose} type='button' />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  )
}

AlertDialog.propTypes = {
  title: PropTypes.string,
  openAlert: PropTypes.bool,
  dialog: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  acceptButtonText: PropTypes.string,
  acceptButtonAction: PropTypes.func,
  acceptButtonType: PropTypes.string,
  cancelButtonText: PropTypes.string,
  disable: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.string,
  translatedTitle: PropTypes.bool,
}

AlertDialog.defaultProps = {
  title: '',
  openAlert: true,
  dialog: '',
  acceptButtonText: 'dialog.accept',
  acceptButtonAction: void 0,
  acceptButtonType: 'button',
  cancelButtonText: 'dialog.cancel',
  disable: false,
  fullWidth: false,
  maxWidth: 'sm',
  translatedTitle: false,
}

export default AlertDialog
